export enum LevelTask {
    FTUX_CARD_MATCH = 'ftux_card_match',
    FTUX_CARD_DECK = 'ftux_card_deck',
    FTUX_BOOSTER_UNDO = 'ftux_booster_undo',
    FTUX_BOOSTER_JOKER = 'ftux_booster_joker',
    FTUX_BOOSTER_TNT = 'ftux_booster_tnt',
    FTUX_BOOSTER_BULLS_EYE = 'ftux_booster_bulls_eye',
    FTUX_BOOSTER_SHUFFLE = 'ftux_booster_shuffle',
    FTUX_SUITCASE = 'ftux_suitcase',
    FTUX_HAZARD_BOMB = 'ftux_hazard_bomb',
    FTUX_LOCK = 'ftux_lock',
    FTUX_RISE_LOWER = 'ftux_rise_lower',
    FTUX_PICKAXE = 'ftux_pickaxe',
    FTUX_WATERMELON = 'ftux_watermelon',
    FTUX_HARVEST_FESTIVAL = 'ftux_harvest_festival',
    FTUX_SCYTHE = 'ftux_scythe',
    FTUX_ICE = 'ftux_ice',
    FTUX_ROPE = 'ftux_rope',
    FTUX_TORNADO = 'ftux_tornado',
    FTUX_FOG = 'ftux_fog',
    FTUX_GOLD = 'ftux_gold',
    FTUX_CONNECTED_CARDS = 'ftux_connected cards',
    FTUX_TNT_MODIFIER = 'ftux_tnt_modifier',
}
